import * as React from 'react';
import type { Maybe, AccessibeSettings } from '@types/gatsby-types';
import { graphql, useStaticQuery } from 'gatsby';
import { useIntl } from 'react-intl';

const query = graphql`
    query AccessibeSettingsQuery {
        settings {
            accessibe {
                enabled
            }
        }
    }
`;

type AccessibeSettingsQuery = {
    settings: Maybe<{
        accessibe: Maybe<AccessibeSettings>;
    }>;
};

type AccessibeTriggerProps = {
    Component?: React.ElementType;
};

export default function AccessibeTrigger({
    Component = 'li',
}: AccessibeTriggerProps) {
    const { settings } = useStaticQuery<AccessibeSettingsQuery>(query);
    const enabled = settings?.accessibe?.enabled;
    const { formatMessage } = useIntl();

    if (enabled) {
        return (
            <Component>
                <button
                    id="accessibilityWidget"
                    onClick={() => {
                        window.UserWay?.widgetOpen();
                    }}
                    tabIndex={0}
                    type="button"
                >
                    {formatMessage({ id: 'a11y.accessibilityTrigger' })}
                </button>
            </Component>
        );
    }

    return null;
}
